module.exports = __webpack_public_path__ + "static/images/index-title-icon-l.86a6bf656.png";